import { fromJS, List, Map } from 'immutable';
import get from 'lodash/get';

import { ApiActions } from '../constants/ApiActions';
import { parseRequestAction } from '../lib/ApiUtils';

const INITIAL_STATE = Map({
  IN_FLIGHT: List(),
  GENRE_REQUEST_TOKEN_MAP: Map(),
});

function reducer(state = INITIAL_STATE, action) {
  try {
    const requestAction = parseRequestAction(action.type);
    if (action.type.endsWith('_ATTEMPT')) {
      return state.merge({
        IN_FLIGHT: state.get('IN_FLIGHT').push({
          requestAction,
          action,
        }),
      });
    }
    if (action.type.endsWith('_SUCCESS') || action.type.endsWith('_FAIL')) {
      const index = state.get('IN_FLIGHT').findIndex(inFlightRequestAction => {
        if (inFlightRequestAction.requestAction === requestAction) {
          // action payload can be mix of obj and immutable
          const candidate = fromJS(
            (inFlightRequestAction.action.request &&
              inFlightRequestAction.action.request.content) ||
              {},
          );
          const searched = fromJS((action.params && action.params.content) || {});
          return candidate.equals(searched);
        }
        return inFlightRequestAction.requestAction === requestAction;
      });

      const newState = {
        IN_FLIGHT: state.get('IN_FLIGHT').delete(index),
      };

      // %%HACK%% The backend services may not always have catalog item tokens in sync with each other.
      // As a fallback, we store a map of the request token to the musicId.
      // See WEBCA-1156
      if (action.type === ApiActions.FETCH_GENRES_BY_CATEGORY_ID_SUCCESS) {
        const requestedToken = get(action, 'request.params.genreTokens');
        const genresResponse = get(action, 'response.entities.genres');
        const genre = Object.values(genresResponse).shift();

        if (requestedToken && requestedToken !== genre.musicId && genresResponse) {
          newState.GENRE_REQUEST_TOKEN_MAP = state
            .get('GENRE_REQUEST_TOKEN_MAP')
            .set(requestedToken, genre.musicId);
        }
      }

      return state.merge(newState);
    }
    return state;
  } catch (e) {
    return state;
  }
}

export default reducer;
